import store from '../data/store.redux';

const getFlowSteps = () => store.getState().flow.steps;

const getCurrentStepIndex = () => {
  const paths = getFlowSteps().map(step => step.path);
  const currentPath = window.location.pathname;
  return paths.indexOf(currentPath);
};

const getFlowContext = () => {
  const steps = getFlowSteps();
  const currentStepIndex = getCurrentStepIndex();

  return {
    steps,
    currentStepNumber: currentStepIndex + 1,
    nextStep: steps[currentStepIndex + 1],
    previousStep: steps[currentStepIndex - 1],
  };
};

export default getFlowContext;
